var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-card",
        { staticStyle: { "margin-bottom": "30px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("强导模型汇总数据"),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.summaryLoading,
                  expression: "summaryLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.summaryData,
                border: "",
                "header-cell-style": _vm.getHeaderCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "导粉部门",
                  width: "120",
                  align: "center",
                  prop: "channel_group_name",
                  fixed: "",
                },
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: "今天", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "测算总订单",
                      "min-width": "100",
                      align: "center",
                      prop: "cs_od",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "可强导订单",
                      "min-width": "110",
                      align: "center",
                      prop: "keqiangdao_od",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "已强导订单",
                      "min-width": "110",
                      align: "center",
                      prop: "yiqiangdao_od",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "强导订单占比",
                      "min-width": "110",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !_vm.showNoGuideEntry(scope.row)
                              ? _c("span", { staticClass: "strong-text" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(scope.row.qiangdao_od_rate) +
                                      "\n                        "
                                  ),
                                ])
                              : _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openNoGuideOrderDialog(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(scope.row.qiangdao_od_rate) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "加粉成功数",
                      "min-width": "100",
                      align: "center",
                      prop: "st",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "加粉率",
                      "min-width": "70",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "strong-text" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(scope.row.st_rate) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: this.currentMonthText, align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "测算总订单",
                      "min-width": "110",
                      align: "center",
                      prop: "offline_cs_od",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "可强导订单",
                      "min-width": "110",
                      align: "center",
                      prop: "offline_keqiangdao_od",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "已强导订单",
                      "min-width": "110",
                      align: "center",
                      prop: "offline_yiqiangdao_od",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "强导订单占比",
                      "min-width": "110",
                      align: "center",
                      prop: "offline_qiangdao_od_rate",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "strong-text " }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(scope.row.offline_qiangdao_od_rate) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "加粉成功数",
                      "min-width": "100",
                      align: "center",
                      prop: "offline_st",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "加粉率",
                      "min-width": "70",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "strong-text " }, [
                              _vm._v(_vm._s(scope.row.offline_st_rate)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("\n            模型配置明细\n        "),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { inline: "", size: "mini" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模型名称" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "230px" },
                      attrs: {
                        placeholder: "模型名称",
                        multiple: "",
                        clearable: "",
                        filterable: "",
                        "collapse-tags": "",
                      },
                      model: {
                        value: _vm.searchPatterns,
                        callback: function ($$v) {
                          _vm.searchPatterns = $$v
                        },
                        expression: "searchPatterns",
                      },
                    },
                    _vm._l(_vm.productPatterns, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onSelectAll } }, [
                    _vm._v("\n                    全选\n                "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导粉部门" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "185px" },
                      attrs: {
                        placeholder: "导粉部门",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchGuides,
                        callback: function ($$v) {
                          _vm.searchGuides = $$v
                        },
                        expression: "searchGuides",
                      },
                    },
                    _vm._l(_vm.guideDepartments, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { on: { click: _vm.onSelectAllGuideDepartments } },
                    [_vm._v("\n                    全选\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "接粉部门" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "185px" },
                      attrs: {
                        placeholder: "接粉部门",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchAccepts,
                        callback: function ($$v) {
                          _vm.searchAccepts = $$v
                        },
                        expression: "searchAccepts",
                      },
                    },
                    _vm._l(_vm.acceptDepartments, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { on: { click: _vm.onSelectAllAcceptDepartments } },
                    [_vm._v("\n                    全选\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模型状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { clearable: "", placeholder: "模型状态" },
                      model: {
                        value: _vm.searchStatus,
                        callback: function ($$v) {
                          _vm.searchStatus = $$v
                        },
                        expression: "searchStatus",
                      },
                    },
                    _vm._l(_vm.userStatus, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { size: "mini" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "维度" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.searchDimensions,
                        callback: function ($$v) {
                          _vm.searchDimensions = $$v
                        },
                        expression: "searchDimensions",
                      },
                    },
                    _vm._l(_vm.dimensions, function (item) {
                      return _c("el-checkbox", {
                        key: item.label,
                        attrs: { label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v("\n                    搜索\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "info",
                        icon: "el-icon-refresh",
                        plain: "",
                      },
                      on: { click: _vm.onReset },
                    },
                    [_vm._v("\n                    重置\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: _vm.isAllExpanded
                          ? "el-icon-arrow-up"
                          : "el-icon-arrow-down",
                      },
                      on: { click: _vm.toggleExpandAll },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.isAllExpanded ? "全部收起" : "全部展开") +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "max-height": "1000",
                "header-cell-style": _vm.getHeaderCellStyle,
              },
              on: { "sort-change": _vm.handleSortChange },
            },
            [
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    key: "remark",
                    attrs: {
                      prop: "remark",
                      label: "模型名称",
                      "min-width": "150",
                      align: "center",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showGuideColumn
                ? _c("el-table-column", {
                    key: "channel_group_name",
                    attrs: {
                      prop: "channel_group_name",
                      label: "导粉部门",
                      "min-width": "150",
                      align: "center",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showAcceptColumn
                ? _c("el-table-column", {
                    key: "department",
                    attrs: {
                      prop: "department",
                      label: "接粉部门",
                      "min-width": "150",
                      align: "center",
                      fixed: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    key: "pattern",
                    attrs: {
                      prop: "pattern",
                      label: "模型标识",
                      "min-width": "150",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showManagerColumn
                ? _c("el-table-column", {
                    key: "od_ltv",
                    attrs: {
                      label: "近十天订单产",
                      "min-width": "130",
                      align: "center",
                      prop: "od_ltv",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "strong-text " }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(scope.row.od_ltv) +
                                    "\n                    "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3714223609
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showManagerColumn
                ? _c("el-table-column", {
                    key: "fan_ltv",
                    attrs: {
                      label: "近十天粉产",
                      "min-width": "120",
                      align: "center",
                      prop: "fan_ltv",
                      sortable: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "strong-text " }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(scope.row.fan_ltv) +
                                    "\n                    "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2220979707
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showManagerColumn
                ? _c("el-table-column", {
                    key: "offline_amount",
                    attrs: {
                      prop: "offline_amount",
                      label: "近十天营收",
                      "min-width": "120",
                      align: "center",
                      sortable: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showManagerColumn
                ? _c("el-table-column", {
                    key: "offline_yiqiangdao_od",
                    attrs: {
                      prop: "offline_yiqiangdao_od",
                      label: "近十天订单数",
                      "min-width": "130",
                      align: "center",
                      sortable: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                key: "yiqiangdao_od",
                attrs: {
                  prop: "yiqiangdao_od",
                  label: "今日订单数",
                  "min-width": "120",
                  align: "center",
                  sortable: "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "st",
                attrs: {
                  prop: "st",
                  label: "今日加粉数",
                  "min-width": "110",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "今日加粉率",
                  "min-width": "120",
                  align: "center",
                  prop: "st_rate",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "strong-text " }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(scope.row.st_rate) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    key: "limit_settings",
                    attrs: {
                      label: "上限设置",
                      align: "center",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  class: _vm.isAllExpanded
                                    ? "expanded-container"
                                    : "single-line-container",
                                },
                                [
                                  scope.row.o_sum
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "list-tag",
                                          attrs: {
                                            type: "info",
                                            effect: "plain",
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.o_sum + "单"))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    scope.row.nextPatternList,
                                    function (v, k) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: k,
                                          staticClass: "list-tag",
                                          attrs: {
                                            type: "info",
                                            effect: "plain",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(v.value) +
                                              ":" +
                                              _vm._s(v.ratios) +
                                              "%\n                        "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4083902151
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPatternColumn
                ? _c(
                    "el-table-column",
                    {
                      key: "guide_settings",
                      attrs: {
                        align: "center",
                        "min-width": "180",
                        label: "强导设置",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: _vm.isAllExpanded
                                      ? "expanded-container"
                                      : "single-line-container",
                                  },
                                  _vm._l(
                                    scope.row.settingTags,
                                    function (v, k) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: k,
                                          staticClass: "list-tag",
                                          attrs: {
                                            type: "info",
                                            effect: "plain",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(v) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1534217341
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "没有标签，默认全开",
                                placement: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v("强导设置"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-question el-icon--right",
                                }),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    key: "scene_id",
                    attrs: {
                      prop: "scene_id",
                      label: "场景id",
                      "min-width": "120",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    key: "status",
                    attrs: {
                      label: "模型状态",
                      "min-width": "80",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.pattern_info
                              ? [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.getStatusText(
                                          scope.row.pattern_info.status
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPatternColumn
                ? _c("el-table-column", {
                    key: "operation",
                    attrs: { label: "操作", fixed: "right", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onModify(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2036979031
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.totalPage > 1
            ? _c(
                "section",
                { staticClass: "pagination-wrap" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-size": _vm.perPage,
                      layout: "prev, pager, next, jumper",
                      "page-count": _vm.totalPage,
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function ($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.currentPage = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("FansManage", {
        ref: "managePop",
        attrs: {
          ruleForm: _vm.chooseData,
          issues: _vm.issues,
          patterns: _vm.patterns,
        },
        on: {
          "update:ruleForm": function ($event) {
            _vm.chooseData = $event
          },
          "update:rule-form": function ($event) {
            _vm.chooseData = $event
          },
        },
      }),
      _vm._v(" "),
      _c("NoGuideDialog", {
        ref: "noGuideDialog",
        attrs: { department: _vm.noGuideDepartment },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }